import React from 'react'
import { useNavigate } from 'react-router-dom'
import styles from './SchoolActionButtons.module.css'

const SchoolActionButtons = ({ schoolIp, schoolName, onOpenHistory, onOpenSpeedtest, additionalUrl }) => {
  const navigate = useNavigate()
  
  const handleHistoryClick = () => {
    if (onOpenHistory) {
      onOpenHistory(schoolIp)
    }
  }

  const handleSpeedtestClick = () => {
    if (onOpenSpeedtest) {
      onOpenSpeedtest(schoolIp)
    }
  }

  const handleDetailsClick = () => {
    if (schoolIp) {
      navigate(`/schools/${encodeURIComponent(schoolIp)}`)
    }
  }

  const handleRuijieClick = () => {
    if (schoolIp) {
      const url = additionalUrl || 'https://sapa.aiqyn-shym.kz/macc5/adminIntl/#/monitor_project_workbarn_menu'
      window.open(url, '_blank', 'noopener,noreferrer')
    }
  }

  return (
    <div className={styles.buttonGrid}>
      <button
        onClick={handleHistoryClick}
        className={styles.actionButton}
        type="button"
      >
        <div className={`${styles.buttonIcon} ${styles.buttonIconInternet}`}>
          <span className="material-icons">timeline</span>
        </div>
        <span className={styles.buttonText}>Internet</span>
      </button>

      <button
        onClick={handleSpeedtestClick}
        className={styles.actionButton}
        type="button"
      >
        <div className={`${styles.buttonIcon} ${styles.buttonIconSpeedtest}`}>
          <span className="material-icons">speed</span>
        </div>
        <span className={styles.buttonText}>Speedtest</span>
      </button>

      <button
        onClick={handleDetailsClick}
        className={styles.actionButton}
        type="button"
      >
        <div className={styles.buttonIcon}>
          <span className="material-icons">info</span>
        </div>
        <span className={styles.buttonText}>Details</span>
      </button>

      <button
        onClick={handleRuijieClick}
        className={styles.actionButton}
        type="button"
      >
        <div className={`${styles.buttonIcon} ${styles.buttonIconSks}`}>
          <span className="material-icons">open_in_new</span>
        </div>
        <span className={styles.buttonText}>СКС</span>
      </button>
    </div>
  )
}

export default SchoolActionButtons

